/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Faq_Online_QInputs */

const en_wc_faq_online_q = /** @type {(inputs: Wc_Faq_Online_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does the online version work?`)
};

/**
* | output |
* | --- |
* | "How does the online version work?" |
*
* @param {Wc_Faq_Online_QInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_faq_online_q = /** @type {((inputs?: Wc_Faq_Online_QInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Faq_Online_QInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_faq_online_q(inputs)
});
export { wc_faq_online_q as "wc.faq.online.q" }